(function () {
    let tabs = document.querySelectorAll(".page-subnavigation__items .page-subnavigation__item");
    let clients = document.querySelector(".service__clients");
    let experiences = document.querySelectorAll(".readmore-button");

    // Do we have a tab in the URL
    const urlParams = new URLSearchParams(window.location.search);
    const stateParam = urlParams.get('tab');
    if (stateParam) {
        document.querySelectorAll(".page-subnavigation__item.active").forEach((x) => x.classList.remove("active"));
        document.querySelectorAll(".service__tab-content--active").forEach((x) => x.classList.remove("service__tab-content--active"));

        let stateTab = document.querySelector(`.page-subnavigation__items .page-subnavigation__item[data-tab=${stateParam}]`)
        if (stateTab) {
            stateTab.classList.add("active");

            let contentElement = document.getElementById(stateParam);
            if (contentElement) {
                contentElement.classList.add("service__tab-content--active");
            }
        }
    }

    if (tabs) {
        tabs.forEach((tab) => {
            tab.addEventListener("click", function (e) {
                e.preventDefault();
                document.querySelectorAll(".page-subnavigation__item.active").forEach((x) => x.classList.remove("active"));
                document.querySelectorAll(".service__tab-content--active").forEach((x) => x.classList.remove("service__tab-content--active"));
                tab.classList.add("active");

                // Push an entry to history state so the user clicks back and hits the same tab
                let newUrl = `${window.location.origin}${window.location.pathname}?tab=${tab.dataset.tab}`;
                if (history.pushState) {
                    history.pushState({}, "", newUrl);
                }

                let contentElement = document.getElementById(e.target.dataset.tab);
                if (contentElement) {
                    contentElement.classList.add("service__tab-content--active");
                }
            });
        });
    }

    if (clients) {
        const selectElement = document.getElementById("service_clients");
        if (selectElement) {
            selectElement.addEventListener("change", (e) => {
                window.open(e.target.value);
            });
        }
    }

    if (experiences) {
        experiences.forEach((experienceItem) => {
            experienceItem.addEventListener("click", function (e) {
                e.preventDefault();
                let target = document.getElementById(e.target.dataset.readmore);
                if (target) {
                    experienceItem.innerText = target.style.display === "none" ? "Read less" : "Read more";
                    target.style.display = target.style.display === "none" ? "block" : "none";
                }
            });
        });
    }
})();
